import { render, staticRenderFns } from "./ManagerLogs.vue?vue&type=template&id=25c59316&scoped=true"
import script from "./ManagerLogs.vue?vue&type=script&lang=ts"
export * from "./ManagerLogs.vue?vue&type=script&lang=ts"
import style0 from "./ManagerLogs.vue?vue&type=style&index=0&id=25c59316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c59316",
  null
  
)

export default component.exports